import client from '../client/client'

const getStatistics = async () => await client.get('/api/v1/admin/statistics')

const getEmailRecipients = async () => client.get('api/v1/admin/statistics-email-recipients')

const saveEmailRecipients = async (payload: {emails: string[]; frequency: string}) =>
  client.post('api/v1/admin/statistics-email-recipients', payload)

export {getStatistics, getEmailRecipients, saveEmailRecipients}